// Only include modules with an existing page and a matching permission claim.
const modules = [
  {
    permission: "article_approval",
    route: "Article",
    label: "module.article",
    icon: "mdi-file-document-outline",
  },
  {
    permission: "products",
    route: "Marketplace",
    query: { tab: "products" },
    label: "module.products",
    icon: "mdi-package-variant-closed",
  },
  {
    permission: "orders",
    route: "Marketplace",
    query: { tab: "orders" },
    label: "module.orders",
    icon: "mdi-cart-outline",
  },
  {
    permission: "event_admin",
    route: "Event",
    label: "module.event",
    icon: "mdi-calendar-outline",
  },
  {
    permission: "sport_club",
    route: "SportClub",
    label: "module.sportClub",
    icon: "mdi-basketball",
  },
  {
    permission: "meeting_room",
    route: "MeetingRoom",
    label: "module.meetingRoom",
    icon: "mdi-door-open",
  },
  {
    permission: "companies",
    route: "Company",
    label: "module.company",
    icon: "mdi-domain",
  },
  {
    permission: "offices",
    route: "Office",
    label: "module.office",
    icon: "mdi-office-building",
  },
  {
    permission: "positions",
    route: "Position",
    label: "module.position",
    icon: "mdi-badge-account-outline",
  },
  {
    permission: "departments",
    route: "Department",
    label: "module.department",
    icon: "mdi-account-group-outline",
  },
  {
    permission: "properties",
    route: "Property",
    label: "module.property",
    icon: "mdi-home-outline",
  },
  {
    permission: "panel",
    route: "Panels",
    label: "module.panel",
    icon: "mdi-hospital-building",
  },
  {
    permission: "configurations",
    route: "Configuration",
    label: "module.configuration",
    icon: "mdi-cog-outline",
  },
];

export function getDashboardShortcuts(permissions = {}) {
  return modules.filter((module) =>
    [1, 2].includes(permissions[module.permission]),
  );
}
